import { TypeStatus } from '@/lib/api/playbackService/types';
import { TypeKeyValuePair } from '@/core/generated-types';

export function getStatusDisplayText(
  status: TypeStatus,
  statusDisplayCopy: TypeKeyValuePair[],
) {
  const statusDisplayCopyIdx = statusDisplayCopy.findIndex(
    (statusMapping) => statusMapping.fields.title === status,
  );

  if (
    statusDisplayCopyIdx !== -1 &&
    statusDisplayCopy[statusDisplayCopyIdx].fields.value.content[0].content
  ) {
    return statusDisplayCopy[statusDisplayCopyIdx].fields.value.content[0]
      .content[0].value;
  }

  return status;
}
